import type { FlightDropdownOption } from 'components/Flights/types'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

interface Props extends Utils.PropsWithDataAttributes {
  selected: boolean
  option: FlightDropdownOption
  onOptionSelect: (option: FlightDropdownOption) => void
}

function FareDropdownOption(props: Props) {
  const { option, onOptionSelect, ...rest } = props
  const intl = useIntl()

  const onSelect = useCallback(() => {
    onOptionSelect(option)
  }, [option, onOptionSelect])

  return (
    <ClickableListItem
      {...rest}
      title={option.label}
      key={option.value}
      onClick={onSelect}
      disabled={option.disabled}
    >
      {option.comingSoon && <StructureLabel variant="information">
        {intl.formatMessage({
          id: 'n1X1QRxI2Giv7WZ4kmOW',
          defaultMessage: 'Coming soon!',
          description: 'Label indicating that a fare option is coming soon',
        })}
      </StructureLabel>}
    </ClickableListItem>
  )
}

export default FareDropdownOption
